import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@bigbank/interface-components/dist/lib/esm.css';

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App as never),
}).$mount('#app');
